import buildIdentity from "./build.json";

export type ReleaseInfo = {
  version: string;
  issuedAt: string;
  sourceSha: string;
  contentHash: string;
  allocationRunId: string;
};

export function parseReleaseInfo(value: unknown): ReleaseInfo | null {
  if (value === null) return null;
  if (typeof value !== "object" || Array.isArray(value)) throw new Error("リリース情報が不正です。");
  const record = value as Record<string, unknown>;
  const keys = ["version", "issuedAt", "sourceSha", "contentHash", "allocationRunId"];
  if (!keys.every(key => typeof record[key] === "string")) throw new Error("リリース情報が不足しています。");
  if (!/^[1-9]\d{3}\.[1-9]\d{0,2}\.[1-9]\d*$/.test(record.version as string)
    || !Number.isFinite(Date.parse(record.issuedAt as string))
    || !/^[a-f0-9]{40}$/.test(record.sourceSha as string)
    || !/^[a-f0-9]{64}$/.test(record.contentHash as string)
    || !/^[1-9]\d*$/.test(record.allocationRunId as string)) throw new Error("リリース情報の形式が不正です。");
  const date = new Date(record.issuedAt as string);
  const [year, day] = (record.version as string).split(".").map(Number);
  const expectedDay = Math.floor((Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate()) - Date.UTC(year, 0, 1)) / 86_400_000) + 1;
  if (date.getUTCFullYear() !== year || day !== expectedDay) throw new Error("リリース番号とUTC日時が一致しません。");
  return record as ReleaseInfo;
}

// 番号JSONはビルドしたソースと一致した場合だけ採用する。古い番号へfallbackしない。
const releaseEnvironment = process.env.NEXT_PUBLIC_ENV_NAME;
if (buildIdentity.schema !== "source-fingerprint-v2" || !/^[a-f0-9]{64}$/.test(buildIdentity.contentHash)) throw new Error("ビルドしたソースの識別情報が不正です。");
export const buildContentHash = buildIdentity.contentHash;
const candidate = parseReleaseInfo(buildIdentity.metadata);
if (candidate && candidate.contentHash !== buildContentHash) throw new Error("ビルドとリリース番号のコードが一致しません。");
const numberedEnvironment = releaseEnvironment === "staging" || releaseEnvironment === "prod";
export const releaseInfo = numberedEnvironment ? candidate : null;
export const releaseVersion = releaseInfo?.version ?? (numberedEnvironment ? "採番待ち" : "開発版");
